//@ts-check

class DebtorAgeAnalysisService {
	constructor(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		FinancialsService,
		LocalStorageService,
		InternalLinksService
	) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.FinancialsService = FinancialsService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.numberOfResults = 0;
		this.numberOfResultsLegal = 0;
		this.debtorAgeAnalysisData = undefined;
	}

	async getDebtorAgeAnalysis(schemeRef, date, sortByUnitNumber, sortByTotal, pageNumber) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('FinancialApiDebtorAgeAnalysis');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiDebtorAgeAnalysis');
			}

			date = this.FinancialsService.getMapFirstDay(date);
			url = url.replace('{schemeRef}', schemeRef).trim();
			url += `?date=${moment(date).format(
				'L'
			)}&sortByUnitNumber=${sortByUnitNumber}&sortByTotal=${sortByTotal}&pageNumber=${pageNumber}`;

			const headers = this.Utility.headersWithContentType;

			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Levy as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.get(url, { headers: headers });
			const { data } = results;
			this.debtorAgeAnalysisData = data.Data[0];
			this.numberOfResults = data.NumberOfResults;
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			this.debtorAgeAnalysisData = [];
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async getUnitLegalMemo(CardCode, date, UnitItemCode) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('FinancialApiLevyRollMemo');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiLevyRollMemo');
			}

			date = this.FinancialsService.getMapFirstDay(date);
			url = url.replace('{CardCode}', CardCode).trim();
			url += `?date=${moment(date).format(
				'L'
			)}`;

			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.get(url, { headers: headers });

			const { data } = results;
			this.DebtorAgeAnalysisUnitMemoData = data.Data;
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			this.DebtorAgeAnalysisUnitMemoData = [];
			this.$timeout(() => promiseHandler.reject(error));
		}
		return promise
	}

	async getCSVReport(schemeRef, date, sortByUnitNumber, sortByTotal, pageNumber) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			date = this.FinancialsService.getMapFirstDay(date)
			let url = await this.InternalLinksService.getLink('FinancialApiDebtorAgeAnalysisCSV');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiDebtorAgeAnalysisCSV');
			}

			date = this.FinancialsService.getMapFirstDay(date);
			url = url.replace('{schemeRef}', schemeRef).trim();
			url += `?date=${moment(date).format(
				'L'
			)}&sortByUnitNumber=${sortByUnitNumber}&sortByTotal=${sortByTotal}&pageNumber=${pageNumber}`;

			const headers = this.Utility.headersWithContentType;

			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Levy as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.get(url, { headers: headers });
			const { data } = results;
			date = moment(date).format(
				'L'
			);
			this.downloadDebtorCSV(data.Data, schemeRef, date);
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			this.DebtorAgeAnalysisUnitMemoData = [];
			this.$timeout(() => promiseHandler.reject(error));
		}
		return promise

	}

	downloadDebtorCSV(base64String, schemeRef, date, filename) {
		var byteCharacters = atob(base64String);
		var byteNumbers = new Array(byteCharacters.length);

		for (var i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}

		var byteArray = new Uint8Array(byteNumbers);
		var blob = new Blob([byteArray], { type: 'text/csv;charset=utf-8;' });
		var link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', filename || schemeRef + ' - DebtorAgeAnalysis - ' + date + '.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	FinancialsService,
	LocalStorageService,
	InternalLinksService
) =>
	new DebtorAgeAnalysisService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		FinancialsService,
		LocalStorageService,
		InternalLinksService
	);
